// extracted by mini-css-extract-plugin
export default {"wrap":"XE-z","fullWidth":"YE-z","hideOnDesktop":"ZE-z","content":"_E-z","hasOpenedNav":"aF-z","crumbsList":"bF-z","dropdownsWrap":"cF-z"};